/* eslint-disable max-len */
import React, { SVGProps } from 'react';
import Icon from './Icon';

const Check: React.FunctionComponent<SVGProps<SVGSVGElement>> = (props) => (
  <Icon width="16px" height="13px" viewBox="0 0 16 13" {...props}>
    <g transform="translate(-1.000000, -6.000000)">
      <path d="M6.37342841,18.3156564 L16.9136865,7.77536398 C17.0784467,7.61063812 17.0784467,7.34349932 16.9136865,7.17873912 L15.9193575,6.1843758 C15.7545973,6.01964994 15.4874928,6.01964994 15.3227326,6.1843758 L6.07511598,15.4319925 L2.67722445,12.0341009 C2.51246426,11.8693407 2.24535979,11.8693407 2.08056526,12.0341009 L1.08623627,13.0284299 C0.921476075,13.1931901 0.921476075,13.4602946 1.08623627,13.6250891 L5.77680355,18.3156564 C5.94152941,18.4803823 6.20863388,18.4803823 6.37342841,18.3156564 Z" />
    </g>
  </Icon>
);

export default Check;
